import { Component, OnInit, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators, ReactiveFormsModule } from '@angular/forms';
import { UtilService } from 'src/app/shared';
import { Router } from '@angular/router';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-contact-no',
  templateUrl: './contact-no.component.html',
  styleUrls: ['./contact-no.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: ConntactNoComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ConntactNoComponent),
      multi: true
    }
  ],
  imports: [ReactiveFormsModule, NgClass]
})
export class ConntactNoComponent implements OnInit {

  onTouched: () => void;
  onChange = (value: string) => { };

  phoneValidator: boolean = false;

  @Input() controllerData;
  @Input() parent: FormGroup;
  @Input() controlName: string;
  @Input() pageName: string;
  @Input() pattern

  @Input() dobDisabled = false;
  @Output() changeHandler: EventEmitter<any> = new EventEmitter<any>();

  disabled: boolean;
  private screenName;


  constructor(private utilService: UtilService,
    private router: Router) { }

  ngOnInit() {
    this.getCurrentScreenURL();
    if (this.screenName === 'your health records' || this.screenName === 'dependant health records') {

      this.parent.get(this.controlName).setValidators([Validators.required]);
    } else {
      this.parent.get(this.controlName).setValidators([]);
    }
  }

  writeValue(value: any): void {
    this.controllerData['value'] = value ? value : null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  validate() {
    // tslint:disable-next-line: max-line-length
    let nameReForContactNo: RegExp;
    if (this.pageName === 'your-personal-details' || this.pageName === 'register') {
      nameReForContactNo = /^[0+]\d+(?: ?\d+)*$/g;
    } else {
      nameReForContactNo = /^[0-9]*$/g;
    }
    const forbidden = nameReForContactNo.test(this.parent.get(this.controlName).value);


    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { notValidPhone: true };
      // tslint:disable-next-line:align
    } return null;
  }
  validateInput = () => {
    this.changeHandler.emit();
  }

  getCurrentScreenURL() {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }

}
